<template>
  <div class="visitor">
    <div class="visitor-guide">
      <div class="content">
        <Welcome></Welcome>
        <EventsMini :serveUrl="flowServeUrl" :request="request" @clickMore="clickMore"/>
      </div>
      <span class="down" @click="scorlltopOne">
          <i class="el-icon-arrow-down"></i>
        </span>
    </div>
    <div>
      <component class="visitor-components" v-for="com in comps" :key="com.name" :is="com.name" />
    </div>
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import Welcome from "./components/Welcome";
import RecServe from "./Tourist/RecServe";
import NewList from "./Tourist/NewList";
export default {
  name: "Visitor",
  components: {
    Welcome,
    RecServe,
    NewList
  },
  computed: {
    ...mapGetters(['token', 'serveUrl', 'request', 'flowServeUrl']),
  },
  data() {
      return {
        comps: [
          {
            name: "RecServe"
          },
          {
            name: "NewList"
          }
        ]
      }
  },
  methods: {
    clickMore(status){
      this.$router.push({ name: "EventsCenter" , params: { tabNum: status } });
    },
    scorlltopOne() {
      this.scrollWrapper = document.querySelector(".app-main-wrapper");
      let wrapper = this.scrollWrapper;
      let top = document.body.clientHeight - 0 - 60;
      let height = this.scrollWrapper.scrollTop || 0;
      let timer = setInterval(function() {
        if (height <= top) {
          height += 10;
          wrapper.scrollTop = height;
        } else {
          clearInterval(timer);
        }
      }, 1);
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";
.visitor {
  width: 100vw;
  position: relative;

  &-content {
    position: absolute;
    top: $nav-height;
  }
  &-guide {
    position: relative;
    min-height: calc(100vh - 60px);
    display: flex;
    justify-content: space-around;
    align-items: center;
    .content {
      width: 100%;
      max-width: 1920px;
      @include  contentMedia;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h3 {
        font-size: 48px;
        color: #ffffff;
        line-height: 48px;
        letter-spacing: 4px;
        font-weight: 400;
      }
      .line {
        width: 1px;
        height: 80px;
        background-color: #ffffff;
        margin: 20px 0;
      }
      .business-list-Mini{
        max-width: 40%;
        flex: 1;
        height: 486px;
        margin-left: 153px;
        border-radius: 6px;
        .el-scrollbar{
          height: 400px;
        }
        .z-segment.is-round .z-segment-cursor{
          color: $color-primary;
        }
      }
    }
    .down {
      width: 19px;
      height: 19px;
      border: 2px solid #ffffff;
      position: absolute;
      bottom: 50px;
      left: 50%;
      margin-left: -11.5px;
      border-radius: 50%;
      line-height: 19px;
      text-align: center;
      //animation: 0.45s ease 0s infinite alternate none running down;
      cursor: pointer;
      i {
        color: #ffffff;
      }
    }
  }
  .visitor-components {
    width: 100%;
    & > div {
      max-width: 1920px;
      margin-left: auto;
      margin-right: auto;
    }
    .section-content{
      @include portalMedia;
    }
    
    min-height: calc(100vh - 60px);
  }
}
</style>
